import Page from '@app/components/layout/page/page';
import SoldPackagingItemForm from '../components/item/sold-packaging-item-form';
import { useSoldPackagingItem } from '../sold-packaging-item-context';

export default function SoldPackagingItemPage() {
  const { item, status } = useSoldPackagingItem();
  return (
    <Page name="Packaging" page="subpage" status={status} flexFullHeight>
      <SoldPackagingItemForm item={item} />
    </Page>
  );
}
